import GetOffset from '../_utils/GetOffset';

export default class UpdateWhenScrolledPast {


	// Constructor
	constructor(element) {
		this.element = element;
		this.scrollMax = -1;
	}


	// Public Methods
	resize() {
		const elementTop = GetOffset.top(this.element);
		const elementHeight = this.element.offsetHeight;
		const windowHeight = window.innerHeight;

		//const elementAppear = elementTop - windowHeight;
		const elementDisappear = elementTop + elementHeight;
		//const elementIsInCenter = elementTop - ((windowHeight - elementHeight) / 2);

		this.scrollMax = elementDisappear - (windowHeight / 2);

		this.scroll();
	}
	scroll() {
		if (this.scrollMax !== -1) {
			const scrollY = window.pageYOffset;
			if (scrollY >= this.scrollMax) {
				this.element.classList.add('is-past');
			} else {
				this.element.classList.remove('is-past');
			}
		}
	}


}
